import React  from "react";
import { TbInfoTriangle } from "react-icons/tb";


const ExpiredRateLimit = (props:any) => {
  
    const {BlockClass} = props

  return (
    <div className={`${BlockClass ? BlockClass : 'w-full h-full'}`}>
        <div className="flex items-center justify-center h-full">
            <div className="flex flex-col items-center justify-center text-center">
                <TbInfoTriangle className="text-2xl text-yellow-800"/>
                <div className='text-primary-light font-medium mt-2 text-xl'>
                    Oops! Your Limit Has Expired
                </div>
                <div className='font-normal mt-1 text-sm font-helveticaNeue text-[#848888]'>
                    It looks like you've reached your limit for today. <br/>
                     No worries! Try again tomorrow or contact support if you need assistance.
                </div>
            </div>
        </div>
      
    </div>
  );
};

export default ExpiredRateLimit;
